import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import attr from './modules/attr'
import product from './modules/product'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    attr,
    product,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js